export default __webpack_public_path__ + "static/tankinis-2011ccd3e2d4ef6415b719ef8ac0f056.webp";